import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from "recharts";
import { Card } from "../common/Card";

const COLORS = [
  "#1E61DC",
  "#10B981",
  "#F59E0B",
  "#8B5CF6",
  "#EC4899",
  "#6B7280",
];

export function ProductMixChart({ revenueByCategory, loading }) {
  const hasData = revenueByCategory?.length > 0;

  return (
    <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
      <h3 className="mb-6 text-[#1A1A1A]">Product Mix</h3>

      {loading ? (
        <div className="h-[350px] flex items-center justify-center">
          <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin" />
        </div>
      ) : hasData ? (
        <ResponsiveContainer width="100%" height={350}>
          <PieChart>
            <Pie
              data={revenueByCategory}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={2}
              dataKey="revenue"
              label={({ category, sharePercentage }) =>
                `${category} ${sharePercentage}%`
              }
            >
              {revenueByCategory.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>

            <Tooltip
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
              formatter={(revenue) => `₦${revenue.toLocaleString()}`}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[350px] flex items-center justify-center text-gray-500">
          No product mix data available
        </div>
      )}
    </Card>
  );
}
